export const SURVEY_ID = 'CA9DC4EE-9A3D-4F17-BEFE-0B11D54D3EE1'
export const RECOMMENDATION_ID = '4CE1CC68-AD90-4C64-A2A2-9B9A1F4542EC'

export const RISK_LEVELS = [
  { id: 1, name: 'low' },
  { id: 2, name: 'medium' },
  { id: 3, name: 'high' }
]

export const FOLLOW_UP_STATUSES = [
  { id: 'OPEN', name: 'not-observed' },
  { id: 'IN PROGRESS', name: 'in-observation' },
  { id: 'CLOSED', name: 'finished-observation' }
]

export const PERIOD_TYPE = [
  { id: 'daily', name: 'daily' },
  { id: 'monthly', name: 'monthly' }
]

export const EMPLOYEE_TYPE = [
  { id: 0, name: 'employee' },
  { id: 1, name: 'non-employee' }
]

export const COMPANY_TYPE = [
  { value: 'ITM Group', name: 'itm-group' },
  { value: 'Vendor', name: 'vendor' },
  { value: 'Contractor', name: 'contractor' },
  { value: 'BOC (Board of Commisioner)', name: 'boc' },
  { value: 'Apperentice', name: 'apperentice' },
  { value: 'Outsource', name: 'outsource' },
  { value: 'Guest', name: 'guest' },
  { value: 'Other', name: 'other' }
]

export const GENDER = [
  { id: true, name: 'male' },
  { id: false, name: 'female' }
]

export const PAGE_SIZES = [10, 50, 100, 250, 500, 1000]
